import { showLoading, hideLoading } from './utils';

export default {
  element       : null,
  toggles       : null,
  rowsParent    : null,
  rows          : null,
  activeOrder   : 'desc',
  activeToggle  : null,
  onStart       : function() {},
  onFinish      : function() {},

  init: function(options) {
    this.element    = $('.sorter');
    this.toggles    = this.element.find('[data-toggle="sorter"]');
    this.rowsParent = this.element.find('.sorter-rows');
    this.rows       = this.rowsParent.find('.sorter-row');

    if(typeof options === 'object') {
      this.onStart = (typeof options.onStart === 'function') ? options.onStart : function() {};
      this.onFinish = (typeof options.onFinish === 'function') ? options.onFinish : function() {};
    }

    this.bind();
  },

  bind: function() {
    this.toggles
      .off('click')
      .on('click', this.sort.bind(this));
  },

  sort: function(e) {
    e.preventDefault();

    showLoading();
    this.onStart();

    var toggle = $(e.currentTarget);
    var sortingValue = toggle.data('sort-by');

    if(this.activeToggle !== null && this.activeToggle === sortingValue) {

      if(this.activeOrder === 'desc') {
        this.activeOrder = 'asc';
      } else {
        this.activeOrder = 'desc';
      }

    } else {
      this.activeToggle = sortingValue;
      this.activeOrder = 'desc';
    }

    this.resetToggles();
    toggle.addClass('is-active');
    toggle.addClass('is-' + this.activeOrder);

    this.rows.sort(function(a, b) {
      var rowA, rowB;
      a = a.dataset[sortingValue];
      b = b.dataset[sortingValue];

      if (isNaN(a) || isNaN(b)) {
        rowA = a.toUpperCase();
        rowB = b.toUpperCase();
      } else {
        rowA = parseInt(a);
        rowB = parseInt(b);
      }

      if (rowA > rowB) { return 1; }
      if (rowA < rowB) { return -1; }

      return 0;
    });

    if(this.activeOrder === 'desc') {
      this.rows.reverse();
    }

    this.sortNodes();
  },

  sortNodes: function() {
    var wrapper = this.rows.parent();

    this.rows.each(function(i) {
      wrapper.append( $(this) );
    });

    this.onFinish();
    hideLoading();
  },

  resetToggles: function() {
    this.toggles.removeClass('is-active is-asc is-desc');
  }
};



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/sorter.js